import React, {useEffect, useState} from 'react';
import {
  Link,
} from "react-router-dom";

import {connect} from 'react-redux';
import passwordValidator from 'password-validator';
// import PaymentMethods from '../payments/PaymentMethods';
import CheckoutForm from '../payments/CheckoutForm';
import {Actions as CREATEACCOUNTACTIONS} from '../../store/actions/createAccountActions';
import {Actions as PAYMENTACTIONS} from '../../store/actions/paymentActions';
// import {Actions as TEAMACTIONS} from './store/actions/teamActions';
// import {Actions as AUTHENTICATIONACTIONS} from './store/actions/authenticationActions';

import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';

import BuddyFace from '../../assets/images/buddy-face.png';

// Make sure to call `loadStripe` outside of a component’s render to avoid
// recreating the `Stripe` object on every render.
const isLive = !(window.location.hostname.includes('stage') || window.location.hostname.includes('local')) 
const stripePromise = loadStripe(isLive ? "pk_live_51HaNWTFTZstRS4WcgEj195NFq0vhkZfc79rYpxhpuWxPD31NGM7j8gRChTJb65wziOuyMEGgFMPsKkfmDruGT8Q000keA5Xgde": "pk_test_51HGJFvARqlCjj4b98dGKPv0wmGuBnhd1UlEELmE0B7LWglLJi03i6ieQDjZ3IOu8Hd5oshnSTaUsUPRlLVcBwvUT00mnga5GLc");

// Create a schema
var schema = new passwordValidator();

// Add properties to it
schema
.is().min(8)                                    // Minimum length 8
.is().max(100)                                  // Maximum length 100
.has().uppercase()                              // Must have uppercase letters
.has().lowercase()                              // Must have lowercase letters
.has().digits(1)                                // Must have at least 1 digits
.has().not().spaces()                           // Should not have spaces
// .is().not().oneOf(['Passw0rd', 'Password123']); // Blacklist these values


function PayAndRegister({
  createAccount,
  updateUserDetails,
  bundles,
  selectBundle,

  error,
  profile,
  selectedBundle,
  invoiceNo,
  creatingAccount,
  userCreated,
  userUpdated,
  acLeadCreated,
  demoAccountCreated,
  specialTerms,
}) {


  useEffect(() => {
    // load initial data required for anywhere
    if (invoiceNo){
      // redirect to app dashboard
      window.location.href = window.location.hostname.includes('stage') || window.location.hostname.includes('local') ? "https://stage.app.buddy.hr/company-settings/" : "https://buddy.hr/company-settings/"
    }
  },[invoiceNo]);

  const [data, setData] = useState({
    noOfEmployees: "1-5",
    name: "",
    surname: "",
    phone: "",
    organisation: "",
    email: "",
    password: "",
  });

            /*<div>
              <label htmlFor="name" className="sr-only">
                First Name
              </label>
              <div className="rounded-md shadow-sm">
                <input name="name" id="name" placeholder="First name" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
              </div>
            </div>

            <div>
              <label htmlFor="surname" className="sr-only">
                Last Name
              </label>
              <div className="rounded-md shadow-sm">
                <input name="surname" id="surname" placeholder="Last name" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
              </div>
            </div>

            <div> 
              <label htmlFor="phone" className="sr-only">
                Phone
              </label>
              <div className="rounded-md shadow-sm">
                <input name="phone" id="phone" placeholder="Phone" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
              </div>
            </div>

            */


  const handleChange = (event) => {
    setData({
      ...data,
      [event.target.name]: event.target.value
    })
  }

  const createDemoAccountSubmit = (e) => {
    e.preventDefault();
    console.log('dataToSubmit',data)
    createAccount(data)
  }

  const updateUserSubmit = (e) => {
    e && e.preventDefault();
    updateUserDetails(data)
  }

  if (invoiceNo){

    return (

      <div className="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg sm:overflow-hidden">
        <div className="px-4 py-8 sm:px-10">

          <div className="mt-6">
            <div>
              <img style={{float:"left", marginRight: 5}} className="h-8 w-auto sm:h-10" src={BuddyFace} alt="Buddy HR Payroll Software Logo"/>
              <h2>Your account is ready, hold tight as we take you to your account.</h2>
            </div>
          </div>
        </div>
        <div className="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10">
          <p className="text-xs leading-5 text-gray-500">
            You're being redirected to your account. This should be quick.
          </p>
        </div>
      </div>
    )
  }


  if (creatingAccount){

    let stepDescription = "Your account is nearly ready, we just need to confirm payment"

    return (

      <div className="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg sm:overflow-hidden">
        <div className="px-4 py-8 sm:px-10">

          <div className="mt-6">
            <form onSubmit={updateUserSubmit} className="space-y-6">


              <div>
                <img style={{float:"left", marginRight: 5}} className="h-8 w-auto sm:h-10" src={BuddyFace} alt="Buddy HR Payroll Software Logo"/>
                <h2>Hi {profile && ((profile.givenName && profile.givenName !== "_") || (profile.name && profile.name !== "_")) ? profile.givenName || profile.name : ''} I'm Buddy, your new payroll companion. Confirm your payment details below.</h2>
              </div>
            
              { !(profile && ((profile.givenName && profile.givenName !== "_") || (profile.name && profile.name !== "_"))) &&
                <React.Fragment>
                  <div>
                    <label htmlFor="name" className="sr-only">
                      Name
                    </label>
                    <div className="rounded-md shadow-sm">
                      <input value={data['name']} onChange={handleChange} name="name" id="name" placeholder="Name" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                    </div>
                  </div>

                  <div>
                    <label htmlFor="surname" className="sr-only">
                      Surname
                    </label>
                    <div className="rounded-md shadow-sm">
                      <input value={data['surname']} onChange={handleChange} name="surname" id="surname" placeholder="Surname" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                    </div>
                  </div>

                  <div>
                    <label htmlFor="phone" className="sr-only">
                      Phone
                    </label>
                    <div className="rounded-md shadow-sm">
                      <input value={data['phone']} onChange={handleChange} name="phone" id="phone" placeholder="Phone" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                    </div>
                  </div>
                </React.Fragment>
              }

              <Elements stripe={stripePromise}>
                <CheckoutForm stripePromise={stripePromise} onSubmit={updateUserSubmit}/>
              </Elements>

              {/*<div>
                <span className="block w-full rounded-md shadow-sm">
                  <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out">
                    Save and Proceed to Payment
                  </button>
                </span>
              </div>*/}
            </form>
          </div>
        </div>
        <div className="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10">
          <p className="text-xs leading-5 text-gray-500">
            {stepDescription}
          </p>
        </div>
      </div>
    )
  }

  if (profile && profile.email){
    return(
      <div id="PayAndRegister" className="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg sm:overflow-hidden">
        <div className="px-4 py-8 sm:px-10">
          <div>
            <p className="text-sm leading-5 font-medium text-gray-700">
              Hi {profile.givenName || profile.name}, looking to create another organisation?
            </p>
            {/*<p className="text-xs text-center leading-5 font-medium text-gray-700">
              Not {profile.givenName || profile.name}, sign out.
            </p>*/}
          </div>

          <div className="mt-6">
            <form onSubmit={createDemoAccountSubmit} className="space-y-6">
              <div>
                <label htmlFor="organisation" className="sr-only">
                  Organisation
                </label>
                <div className="rounded-md shadow-sm">
                  <input value={data['organisation']} onChange={handleChange} name="organisation" id="organisation" placeholder="Organisation" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
                </div>
              </div>

              <div>
                <label htmlFor="noOfEmployees" className="sr-only">
                  No of Employees
                </label>
                <div className="rounded-md shadow-sm">
                  <select onChange={handleChange} name="noOfEmployees" id="noOfEmployees" className="mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5">
                    <option value="1-5">1-5 Employees</option>
                    <option value="6-10">6-10 Employees</option>
                    <option value="11-20">11-20 Employees</option>
                    <option value="21-40">21-40 Employees</option>
                    <option value="41-80">41-80 Employees</option>
                    <option value="81-200">81-200 Employees</option>
                    <option value="200+">200+ Employees</option>
                  </select>
                </div>
              </div>

              <div>
                <span className="block w-full rounded-md shadow-sm">
                  <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out">
                    Sign-up now for <strong className="ml-1">€{selectedBundle && selectedBundle.price}</strong>
                  </button>
                </span>

                {!specialTerms && 
                  <span className="block text-center mt-4 text-gray-500 text-xs" style={{cursor:"pointer"}} onClick={() => selectBundle(null)}>
                    Choose another bundle
                  </span>
                }
              </div>
            </form>
          </div>
        </div>
        <div className="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10">
          <p className="text-xs leading-5 text-gray-500">By signing up, you agree to our <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Terms</a>, <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Data Policy</a> and <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Cookies Policy</a>.</p>
          {specialTerms && <p className="text-xs leading-5 text-gray-500 mt-5">{specialTerms}</p>}
        </div>
      </div>
    )
  }

  return (

    <div id="PayAndRegister" className="bg-white sm:max-w-md sm:w-full sm:mx-auto sm:rounded-lg sm:overflow-hidden">
      <div className="px-4 py-8 sm:px-10">
        {/*<div>
          <p className="text-sm leading-5 font-medium text-gray-700">
            Sign in with
          </p>

          <div className="mt-1 grid grid-cols-3 gap-3">
            <div>
              <span className="w-full inline-flex rounded-md shadow-sm">
                <button type="button" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out" aria-label="Sign in with Facebook">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M20 10c0-5.523-4.477-10-10-10S0 4.477 0 10c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V10h2.54V7.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V10h2.773l-.443 2.89h-2.33v6.988C16.343 19.128 20 14.991 20 10z" clipRule="evenodd" />
                  </svg>
                </button>
              </span>
            </div>

            <div>
              <span className="w-full inline-flex rounded-md shadow-sm">
                <button type="button" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out" aria-label="Sign in with Twitter">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M6.29 18.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0020 3.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.073 4.073 0 01.8 7.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 010 16.407a11.616 11.616 0 006.29 1.84" />
                  </svg>
                </button>
              </span>
            </div>

            <div>
              <span className="w-full inline-flex rounded-md shadow-sm">
                <button type="button" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md bg-white text-sm leading-5 font-medium text-gray-500 hover:text-gray-400 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition duration-150 ease-in-out" aria-label="Sign in with GitHub">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clipRule="evenodd" />
                  </svg>
                </button>
              </span>
            </div>
          </div>
        </div>

        <div className="mt-6 relative">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-300"></div>
          </div>
          <div className="relative flex justify-center text-sm leading-5">
            <span className="px-2 bg-white text-gray-500">
              Or
            </span>
          </div>
        </div>*/}

        <div className="mt-6">

          {error && 
            <div className="rounded-md bg-red-50 p-4 mb-6">
              <div className="flex">
                <div className="ml-3">
                  <h3 className="text-sm leading-5 font-medium text-red-800">
                    Error: {error}
                  </h3>
                </div>
              </div>
            </div>
          }

          <form onSubmit={createDemoAccountSubmit} className="space-y-6">
            <div>
              <label htmlFor="organisation" className="sr-only">
                Organisation
              </label>
              <div className="rounded-md shadow-sm">
                <input value={data['organisation']} onChange={handleChange} name="organisation" id="organisation" placeholder="Organisation" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
              </div>
            </div>

            <div>
              <label htmlFor="noOfEmployees" className="sr-only">
                No of Employees
              </label>
              <div className="rounded-md shadow-sm">
                <select onChange={handleChange} name="noOfEmployees" id="noOfEmployees" className="mt-1 form-select block w-full pl-3 pr-10 py-2 text-base leading-6 border-gray-300 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 sm:text-sm sm:leading-5">
                  <option value="1-5">1-5 Employees</option>
                  <option value="6-10">6-10 Employees</option>
                  <option value="11-20">11-20 Employees</option>
                  <option value="21-40">21-40 Employees</option>
                  <option value="41-80">41-80 Employees</option>
                  <option value="81-200">81-200 Employees</option>
                  <option value="200+">200+ Employees</option>
                </select>
              </div>
            </div>

            <div>
              <label htmlFor="email" className="sr-only">
                Email
              </label>
              <div className="rounded-md shadow-sm">
                <input value={data['email']} onChange={handleChange} name="email" id="email" placeholder="Email" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
              </div>
            </div>

            <div>
              <label htmlFor="password" className="sr-only">
                Password
              </label>
              <div className="rounded-md shadow-sm">
                <input value={data['password']} onChange={handleChange} name="password" id="password" type="password" placeholder="Password" required className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md placeholder-gray-400 focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"/>
              </div>
            </div>

            {/*
                passwordValidation && passwordValidation.length > 0 && passwordValidation[0] != "notEqual" &&
                <div className="col-xs-12 alert-danger alert">
                  <h5 style={{
                    textAlign: "left",

                  }}>Your password must have at least.</h5>
                  <ul style={{
              listStyle: "disc",
              paddingLeft: "20px",
              textAlign: "left",
                  }}>
                    <li>8 characters long</li>
            <li>1 uppercase &amp; 1 lowercase character</li>
            <li>1 number</li>
                  </ul>
                </div>
            */}
            <div>
              <span className="block w-full rounded-md shadow-sm">
                <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-orange-600 hover:bg-orange-500 focus:outline-none focus:border-orange-700 focus:shadow-outline-orange active:bg-orange-700 transition duration-150 ease-in-out">
                  Sign-up now for <strong className="ml-1">€{selectedBundle && selectedBundle.price}</strong>
                </button>
              </span>

              {!specialTerms && 
                <span className="block text-center mt-4 text-gray-500 text-xs" style={{cursor:"pointer"}} onClick={() => selectBundle(null)}>
                  Choose another bundle
                </span>
              }
            </div>
          </form>
        </div>
      </div>
      <div className="px-4 py-6 bg-gray-50 border-t-2 border-gray-200 sm:px-10">
        <p className="text-xs leading-5 text-gray-500">By signing up, you agree to our <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Terms</a>, <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Data Policy</a> and <a target="_blank" href="/terms" className="font-medium text-gray-900 hover:underline">Cookies Policy</a>.</p>
        {specialTerms && <p className="text-xs leading-5 text-gray-500 mt-5">{specialTerms}</p>}
      </div>
    </div>
    
    
  );
}

const mapStateToProps = (state) => {

  // const {
  //   myAgreements,
  // } = state.my

  const createAccount = state && state.createAccount
  const profile = state && state.my && state.my.profile

  return {
    invoiceNo: state.payment.invoiceNo,
    creatingAccount: createAccount.creating || state.payment.stripe.savingCard || state.payment.stripe && state.payment.stripe.processingCharge,
    error: createAccount.error,
    userCreated: createAccount.userCreated,
    userUpdated: createAccount.userUpdated,
    acLeadCreated: createAccount.acLeadCreated,
    demoAccountCreated: createAccount.demoAccountCreated,
    bundles: state.payment.bundles,
    selectedBundle: state.payment.selectedBundle,
    profile,
  }
}

const mapDispatchToProps = dispatch => ({
  createAccount: (data) => dispatch(CREATEACCOUNTACTIONS.createAccount(data)),
  updateUserDetails: (data) => dispatch(CREATEACCOUNTACTIONS.updateUserDetails(data)),
  getBundles: () => dispatch(PAYMENTACTIONS.getBundles()),
  selectBundle: (bundle) => dispatch(PAYMENTACTIONS.selectBundle(bundle)),
  // myGetAgreements: () => dispatch(MYACTIONS.myGetAgreements()),
  // getProfile: () => dispatch(MYACTIONS.getProfile()),
  // isLoggedIn: () => dispatch(AUTHENTICATIONACTIONS.isLoggedIn()),
  // getDepartments: () => dispatch(TEAMACTIONS.getDepartments()),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(PayAndRegister) 
